// Utility to check which tables exist in Supabase
import { supabase } from '@/lib/supabaseClient';

export const checkExistingTables = async () => {
  const tablesToCheck = [
    'offers',
    'clients', 
    'products',
    'materials',
    'offer_items',
    'offer_statistics',
    'users',
    'roles',
    'permissions',
    'user_settings',
    'employees',
    'production_orders',
    'production_tasks',
    'quality_controls',
    'quality_reports',
    'payroll',
    'attendance',
    'social_posts',
    'social_campaigns',
    'telegram_settings',
    'telegram_messages',
    'chatbot_conversations',
    'chatbot_messages'
  ];

  const existingTables: string[] = [];
  const missingTables: string[] = [];

  console.log('🔍 Checking database tables...');

  for (const table of tablesToCheck) {
    try {
      const { error } = await supabase
        .from(table)
        .select('*')
        .limit(1);
      
      if (!error) {
        existingTables.push(table);
        console.log(`✅ Table exists: ${table}`);
      } else if (error.code === '42P01') {
        missingTables.push(table);
        console.log(`❌ Table missing: ${table}`);
      } else {
        // Table exists but may have permission issues
        existingTables.push(table);
        console.log(`⚠️ Table exists but has issues: ${table}`, error.message);
      }
    } catch (err) {
      missingTables.push(table);
      console.log(`❌ Error checking table ${table}:`, err);
    }
  }

  console.log('\n📊 Summary:');
  console.log(`✅ Existing tables (${existingTables.length}):`, existingTables);
  console.log(`❌ Missing tables (${missingTables.length}):`, missingTables);

  return { existingTables, missingTables };
};
